module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-searchbox-box-type"
    }
  }, [_c('hrms-search-box', {
    attrs: {
      "receivedStore": _vm.receivedStore,
      "nowLang": _vm.nowLang,
      "searchBoxAlias": "demo-searchbox-box-type"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-673b2e0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoSearchboxBoxType.vue
// module id = 3826
// module chunks = 1